import { useState } from 'react';
import { resendSignup } from '../../api/plans';
import { useT } from '../../i18n/i18n.tsx';
import { Button, InlineAlert } from '../../ui';

/**
 * MVP-278 email verification. "Check your email", the address, and a button that mails the link
 * again. Shown after sign-up and by the sign-in card when the server says EMAIL_NOT_CONFIRMED. The
 * server answers resend with the same 200 whatever the address, so "sent" here means "asked".
 */
export function CheckEmail({ email }: { email: string }) {
  const t = useT();
  const [state, setState] = useState<'idle' | 'sending' | 'sent' | 'failed'>('idle');

  async function resend() {
    setState('sending');
    try {
      await resendSignup(email);
      setState('sent');
    } catch {
      setState('failed');
    }
  }

  return (
    <>
      <h2 className="text-heading">{t('auth.checkEmail.title')}</h2>
      <p className="text-body">{t('auth.checkEmail.body', { email })}</p>
      {state === 'sent' && <InlineAlert variant="ok">{t('auth.checkEmail.resent')}</InlineAlert>}
      {state === 'failed' && <InlineAlert variant="danger">{t('auth.checkEmail.resendFailed')}</InlineAlert>}
      <Button variant="secondary" size="lg" fullWidth loading={state === 'sending'} onClick={resend}>
        {t('auth.checkEmail.resend')}
      </Button>
    </>
  );
}
